/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Grid} from '@mui/material';
import TopProjectsBarChart from './TopProjectsBarChart';
import ResourceTowerBarChart from './ResourceTowerBarChart';
import PieChartWithCustomizedLabel from './CostPoolPieChart';
import ActualsCard from './MetricCard';

const flexContainerStyle: React.CSSProperties = {
  width: '98%',
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr',
  gridTemplateRows: 'max-content',
  rowGap: '10px',
  columnGap: '10px',
  padding: '10px'
};
const flexStyle: React.CSSProperties = {
  gap: '10px',
  width: '100%'
};
const flexItemStyle: React.CSSProperties = {
  textAlign: 'center',
  fontSize: '30px',
  display: 'grid'
};

const item6Style: React.CSSProperties = {
  gridColumnStart: 2,
  gridColumnEnd: 4
};
const item1Style: React.CSSProperties = {
  gridColumnStart: 1,
  gridColumnEnd: 5
};
const linebar: React.CSSProperties = {
  border: 0,
  height: '1px' /* Adjust the color as needed */
};
const ARDashboardComponent = () => {
  return (
    <div style={flexContainerStyle}>
      <div
        style={{
          ...flexItemStyle,
          ...item1Style,
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center'
        }}>
        <h6
          style={{
            alignItems: 'center',
            display: 'flex',
            fontSize: 'x-large',
            fontWeight: '550',
            margin: '15px'
          }}>
          Insights current triggered as of March, 2024
        </h6>
      </div>
      <div
        style={{
          ...flexItemStyle,
          ...item1Style,
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center'
        }}>
        <div style={flexStyle}>
          <ActualsCard />
        </div>
      </div>
      <div style={{...flexItemStyle, gridColumn: ' 1 / 5'}}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <PieChartWithCustomizedLabel />
          </Grid>
          <Grid item xs={6}>
            <TopProjectsBarChart />
          </Grid>
          <Grid item xs={3}>
            <ResourceTowerBarChart />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ARDashboardComponent;
